const initialState = {
  presentationHistory: [],
};

const presentationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PRESENTATION_HISTORY":
      return {
        ...state,
        presentationHistory: action.payload,
      };
    default:
      return state;
  }
};
export default presentationReducer;
